let pluginsList: string[] = [
  'advlist',
  /*
    'anchor',
  */
  /*
    'autolink',
  */
  'autoresize',
  /*
    'autosave',
  */
  /*
    'bbcode',
  */
  'charmap',
  'code',
  /*
    'codesample',
  */
  /*
    Color picker plugin is now built in to the core editor,
    please remove it from your editor configuration
    'colorpicker',
  */

  /*
    Context menu plugin is now built in to the core editor,
    please remove it from your editor configuration
    'contextmenu',
  */
  /*
    for right-to-left languages
    'directionality',
  */
  'emoticons',
  /*
    'fullpage',
  */
  /*
    'fullscreen',
  */
  /*
    'help',
  */
  'hr',
  'image',
  'imagetools',
  'importcss',
  /*
    'insertdatetime',
  */
  /*
    'legacyoutput',
  */
  'link',
  'lists',
  'media',
  'nonbreaking',
  /*
    'noneditable',
  */
  /*
    'pagebreak',
  */
  'paste',
  /*
    'preview',
  */
  /*
    'print',
  */
  /*
    'quickbars',
  */
  /*
    'save',
  */
  /*
    'searchreplace',
  */
  /*
    'spellchecker',
  */
  /*
    'tabfocus',
  */
  'table',
  /*
    'template',
  */
  /*
    Text color plugin is now built in to the core editor,
    please remove it from your editor configuration
    'textcolor',
   */
  /*
    'textpattern',
  */
  /*
    'toc',
  */
  /*
    'visualblocks',
  */
  /*
    'visualchars',
  */
  /*
    'wordcount',
  */
];

let init = {
  base_url: '/static/tinymce', // Root for resources
  suffix: '.min',       // Suffix to use when loading resources
  plugins: pluginsList.join(' '),
  branding: false,
  elementpath: false,
  menubar: 'edit insert view format table tools',
  statusbar: false,
  custom_undo_redo_levels: 20
  // toolbar: 'undo redo | bold italic | bullist numlist outdent indent'
};

export const tinyMceConfig = {
  init: init
} as const;

